<template>
  <zj-layout-container class="zj-resources-team-manage">
    <zj-layout-main>
      <el-tabs v-model="activeName" class="bgcolor">
        <el-divider></el-divider>
        <el-tab-pane label="基本信息" name="first">
          <ComponentResourcesTeaminfo :query="queryProp" @ChangeTab="ChangeTab"/>
        </el-tab-pane>
        <el-tab-pane label="队员信息" name="second" v-if="!operadd">
          <ComponentResourcesTeamPlayerlist :query="queryProp"/>
        </el-tab-pane>
      </el-tabs>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
import ComponentResourcesTeaminfo from "./ResourcesTeaminfo";
import ComponentResourcesTeamPlayerlist from "./ResourcesTeamPlayerlist";

export default {
  name: "ZjResourcesTeamManage",
  controller: "EmergencyResource",
  action: "ResourcesTeamManage",
  components: {
    ComponentResourcesTeaminfo: ComponentResourcesTeaminfo,
    ComponentResourcesTeamPlayerlist: ComponentResourcesTeamPlayerlist
  },
  props: {
    query: {
      type: String,
      obj: String,
      oper:String
    }
  },
  data() {
    return {
      activeName: "first",
      queryProp:this.query,
      operadd:this.query.oper=="add"
    };
  },
  methods: {
     ChangeTab(val){
       this.activeName=val;
     }
  }
};
</script>

<style>
/* tab 顶部样式 */
.zj-resources-team-manage .el-tabs {
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}
.zj-resources-team-manage .el-tabs__header {
  flex: 0 0 auto;
}
.zj-resources-team-manage .el-tabs__content {
  flex: 1 1 auto;
}
.zj-resources-team-manage .el-tab-pane {
  height: 100%;
  overflow: hidden;
}
.zj-resources-team-manage .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
.zj-resources-team-manage .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 2rem;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__item {
  color: #acb8c7;
  font-size: 1.6rem;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__item.is-active {
  color: #ffffff;
  font-size: 1.6rem;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__item:hover {
  color: #ffffff;
  font-size: 1.6rem;
  cursor: pointer;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__nav {
  padding-bottom: 1rem;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__nav-next,
.zj-resources-team-manage .el-tabs__nav-prev {
  font-size: 1.6rem;
  color: #2ac1ff;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.zj-resources-team-manage .el-tabs--top .el-tabs__active-bar {
  bottom: 1.2rem;
  height: 2px;
  background-color: #409eff;
  border-radius: 2px;
  box-shadow: 0px 0.5rem 0.5rem rgba(64, 158, 255, 0.7);
}
</style>